module.exports = __webpack_public_path__ + "media/icons/info-5bedba9c.svg";